import React, { useState, useEffect } from "react";
import Black_Arrow from "../../Assets/Icons/Black_Arrow.svg";
import HCarosel from "../../Component/Carosel/Carosel";
import ImageCarosel from "../../Component/Carosel/Image_Carosel";
import moment from "moment";
import {
  Grid,
  Typography,
  CardActionArea,
  Card,
  CardContent,
  Button,
  Autocomplete,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CardActions,
} from "@mui/material";

const Activities_Data = ({ data = [], title }) => {
  const [filterData, setFilterData] = useState([]);
  const [filterDate, setFilterDate] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const openImageModal = (item) => {
    setSelectedImage(item);
    setIsDialogOpen(true);
  };

  const closeImageModal = () => {
    setSelectedImage(null);
    setIsDialogOpen(false);
  };

  const filterDataByDate = (date) => {
    if (!Array.isArray(data)) {
      console.error("Data is not an array:", data);
      return;
    }

    if (!date) {
      setFilterData(data);
      return;
    }

    const filteredData = data.filter(
      (item) =>
        item.date && moment(item.date).year().toString() === date.toString()
    );
    setFilterData(filteredData);
  };

  const years = [
    "",
    ...Array.from(
      new Set(
        (Array.isArray(data) ? data : []) // Ensure `data` is an array
          .map((item) => moment(item.date).year().toString()) 
          .filter(Boolean)
      )
    ).sort((a, b) => b - a), // Sort in descending order
  ];
  
  
  useEffect(() => {
    if (Array.isArray(data)) {
      setFilterData(data);
    } else {
      console.error("Expected an array but got:", data);
      setFilterData([]); // Set empty array if `data` is not valid
    }
  }, [data]);
  

  const handleChange = (event, newValue) => {
    setFilterDate(newValue);
    filterDataByDate(newValue);
  };

  return (
    <section>
      <HCarosel />
      <div className="container py-4">
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <h4 className="mt-4">{filterData[0]?.page_name}</h4>
          </div>
          <div style={{ width: "20%", height: "auto" }}>
            <Autocomplete
              options={years}
              value={filterDate}
              onChange={handleChange}
              renderInput={(params) => (
                <TextField {...params} label="Year" variant="standard" />
              )}
              getOptionLabel={(option) =>
                option === "" ? "All Years" : option
              }
            />
          </div>
        </div>
        <div>
          <Grid container spacing={3} className="py-4">
            {/* Show 'No Data Found' when there is no filtered data */}
            {filterData.length === 0 ? (
              <Grid item xs={12}>
                <Typography variant="h6" color="text.secondary" align="center">
                  No Data Found
                </Typography>
              </Grid>
            ) : (
              filterData.map((item, index) => (
                <Grid item xs={12} md={index < 2 ? 6 : 4} key={index}>
                  <Card className="ECard mx-2">
                    <CardActionArea onClick={() => openImageModal(item)}>
                      <ImageCarosel image_data={item.image_urls} />
                      <CardContent>
                        <Typography gutterBottom variant="h6">
                          {item.heading}
                        </Typography>
                        <Typography
                          className="activity_description"
                          variant="body2"
                          color="text.secondary"
                          style={{
                            display: "-webkit-box",
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxHeight: "3.6rem",
                          }}
                        >
                          {item.description}
                        </Typography>
                      </CardContent>
                      <CardActions className="d-flex align-items-center justify-content-between">
                        {item.date}
                        <img src={Black_Arrow} alt="Arrow" />
                      </CardActions>
                    </CardActionArea>
                  </Card>
                </Grid>
              ))
            )}
          </Grid>
        </div>
      </div>

      {/* Dialog for Image Modal */}
      <Dialog
        open={isDialogOpen}
        onClose={closeImageModal}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          {selectedImage && (
            <>
              <h4>{selectedImage.heading}</h4>
              <p>{selectedImage.description}</p>
            </>
          )}
        </DialogTitle>
        <DialogContent>
          {selectedImage && (
            <ImageCarosel image_data={selectedImage.image_urls} />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={closeImageModal} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </section>
  );
};

export default Activities_Data;
